"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
exports.getScope = function (payload) { return lodash_1.get(payload, 'scope'); };
exports.getValue = function (payload) { return lodash_1.get(payload, 'value', payload); };
exports.getScopeAndValue = function (payload) {
    var scope = exports.getScope(payload);
    var value = exports.getValue(payload);
    return {
        scope: scope,
        value: value,
    };
};
